import {
  FETCH_ALL_IMAGES,
  FETCH_IMAGE,
  UPLOAD_IMAGE,
  UPDATE_IMAGE,
  DELETE_IMAGE,
} from "./types";

const initialState = {
  loading: false,
  message: null,
  data: [],
  pagination:{}
};

export const galleryReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${FETCH_ALL_IMAGES}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${FETCH_ALL_IMAGES}_FULFILLED`:
      const result = action.payload.data.results
        ? action.payload.data.results.data
        : [];
        const pagination = action.payload.data.results ? action.payload.data.results.pagination : {}
      return {
        ...state,
        loading: false,
        data: result,
        pagination: pagination,
        message: action.payload.data.message,
      };

    case `${FETCH_ALL_IMAGES}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};

export const imageReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${FETCH_IMAGE}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${FETCH_IMAGE}_FULFILLED`:
      const result = action.payload.data.results
        ? action.payload.data.results
        : {};
      return {
        ...state,
        loading: false,
        data: result,
        message: action.payload.data.message,
      };

    case `${FETCH_IMAGE}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};

export const uploadImageReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${UPLOAD_IMAGE}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${UPLOAD_IMAGE}_FULFILLED`:
      return {
        ...state,
        loading: false,
        data: action.payload.results ? action.payload.results : {},
        message: action.payload.message,
      };

    case `${UPLOAD_IMAGE}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};

export const updateImageReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${UPDATE_IMAGE}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${UPDATE_IMAGE}_FULFILLED`:
      return {
        ...state,
        loading: false,
        data: action.payload.results ? action.payload.results : {},
        message: action.payload.message,
        error: action.payload.error,
      };

    case `${UPDATE_IMAGE}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};

export const deleteImageReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${DELETE_IMAGE}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${DELETE_IMAGE}_FULFILLED`:
      return {
        ...state,
        loading: false,
        data: action.payload ? action.payload.message : {},
        message: action.payload.message,
        error: action.payload.error,
      };

    case `${DELETE_IMAGE}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};
